import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Queries, Mutations } from "../../../graphql";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  Tabs,
  Typography,
  Spin,
  Row,
  Col,
  Input,
  message,
  Table,
  Icon,
  Button,
  Popconfirm,
  Form,
  Select,
  DatePicker,
  Tooltip,
  TimePicker,
  Tag,
  Collapse
} from "antd";
import Container from "../../../components/user/Container";
import { changeFormatdate, checkMoreThanLess } from "../../../utils/formatdate";
import { alertMessage } from '../../../utils/message';
import { UrlAbstainTime, getToken, workforce, checkLinkURL } from '../../../utils/auth';
import axios from 'axios';
import { apiKeyNews } from '../../../utils/apiKey'
import { convertToHTMl } from '../../../utils/markDown'
// import { checkStatusForm } from '../../../utils/AlwaysUpcoming'
import moment from "moment";

const { TabPane } = Tabs;
const { Text, Title } = Typography;
const { Option } = Select;
const { Panel } = Collapse;

const newsDataProfile = "";
const format = 'HH:mm';

class Dashboard extends Component {
   state = {
      // loading: true,
      loadingFullpage: true,
      dataTalbe:[],
      columns: [
         {
         // title: 'เลขที่เอกสาร',
            title: "ลำดับ",
            dataIndex: "no",
            align:'center',
            render: (item, record, index) => <span>{index+1}</span>,
            // render: (item, record, index) => <span>{ item }</span>
         },
         {
            title: "ชื่อหลักสูตร",
            dataIndex: "courseName",
            // width: "150px",
            align:"center",
            render: (item, record, index) => (
               <div align="left">
                  <span>{ item ? item : '-' }</span><br></br>
                  <Tag>รหัสหลักสูตร : { record.courseCode }</Tag>
                  {
                     record.description && 
                     <Tooltip 
                        placement="topLeft" 
                        title={
                           // <Text className="color-white">{ record.description }</Text>
                           <div style={{color:"#fff" }} dangerouslySetInnerHTML={{ __html: convertToHTMl(record.description) }} />
                        }
                     >
                        <Icon type="info-circle" />
                     </Tooltip>
                  }
                  
               </div>
            ),
         },
         {
            title: "ประเภทการพัฒนา",
            dataIndex: "learningTypeName",
            width: "150px",
            // width: "150px",
            render: (item, record, index) => (
               <span>{ item ? item : '-' }</span>
            
            ),
         },
         {
            title: "หมวดหมู่หลักสูตร",
            dataIndex: "categoryName",
            render: (item, record, index) => (
               <span>{ item ? item : '-' }</span>
            
            ),
         },
         {
            title: "วันที่เริ่ม",
            dataIndex: "startDate",
            align: "center",
            render: (item, record, index) => (
               <span>{ item ? changeFormatdate(moment(item)) : '-' }</span>            
            ),
         },
         {
            title: "วันที่สิ้นสุด",
            dataIndex: "endDate",
            align: "center",
            render: (item, record, index) => (
               <span>{ item ? changeFormatdate(moment(item)) : '-' }</span>
            ),
         },
         {
            title: "ระยะเวลาหลักสูตร",
            dataIndex: "hoursText",
            align: "center",
            width: "150px",
            render: (item, record, index) => (
               <span>{ item ? item : '-' }</span>
            
            ),
         },
         {
            title: "สถานะฝึกอบรม",
            dataIndex: "learningStatusText",
            align: "center",
            // render: (item, record, index) => <span>{}</span>
            render: (item, record, index) => (
                  // <span style={{ color:`${record.learningStatus == 'D' ? '#0BC133' : '#d7222a'}` }}>{ item }</span>
                  <span>{ item ? item : '-' }</span>
            ),
         },
      ],
      pageData: {
         offset: 0,
         limit: 10,
      },
      pagination: {
         total: 10,
      },
      dataTalbeTotalAll: 0,
      preLoadSubmit: false,
      formValue: null,
      loginPerson: null,
      employeeCodes: null,
      dropDownlearningType: [],
      dropDownCategory: [],

   };

   checkStatusForm = (status) =>{
      let statusShow = this.state.dropDownTypelearningStatus.filter(detail => {
         return detail.label === status
       });

      //  return 
   }

   fetchProfile = async () => {
      try {
         const { client } = this.props;
         const { data } = await client.query({
            query: Queries.fetchProfile,
         });

         await this.setState({
            loginPerson: data.fetchProfile,
            loadingFullpage: false,
            employeeCodes: data.fetchProfile.employeeCodes[0]
         });
         // return data.fetchProfile

         // console.log('data.fetchProfile', data.fetchProfile)
         // await this.fetchListLearningESS()
         // console.log("FETCH PROFILE:", data.fetchProfile);
         // console.log("FETCH emp:", data.fetchProfile.employeeCodes[0]);
      } catch (e) {}
   };

   paginationChange = async (e) => {
      const { formValue, empCode } = this.state;
      const { form, afterSubmit, client } = this.props;
      // await e.preventDefault()

      // console.log("pagination e",e)
      // console.log("pagination values",values)
      let offset = 0;
      if (e.current === 1) {
         offset = 0;
      } else {
         offset = e.current - 1 + "0";
      }

      await this.setState({
         pageData: {
            offset: parseInt(offset),
            limit: 10,
         },
      });
      await this.setState({
         pageData: {
            offset: parseInt(offset),
            limit: 10,
         },
         currentPage: e.current,
      });

      // await this.fetchListPost()
      if (formValue) {
         // console.log("paginationChange formvalue!!", values);
         await this.handleSubmitfetchListLearningESS(formValue);
      } else {
         await this.fetchListLearningESS();
      }
   };

   handleSubmitfetchListLearningESS = async (e) => {
      const { token } = getToken()
      const { form, afterSubmit, client } = this.props;
      const { offset, limit, employeeCodes, pageData } = this.state;

      await e.preventDefault()
      form.validateFields(async (err, values) => {
			const API_DEVICE_KEY = atob(apiKeyNews())

         const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'apiKey': API_DEVICE_KEY
         }

         axios.post(`${workforce()}/fetchListLearningESS/`,{
            // Authorization: token,
            // apiKey: API_DEVICE_KEY,
            args:{
               // offset: parseInt(offset),
               // limit: parseInt(limit),
               ...pageData,
               empCode: employeeCodes,
               // empCode:"415023",
               searchKeyword: {
                  ...values
                  // courseName: "",
                  // categoryId:"",
                  // learningType:"",
                  // learningStatus:""
               }
            }
         },
         {
            headers: headers
         })
         .then(async (response) => {
            await this.setState({
               dataTalbe: response.data.data.data,
               dataTalbeTotalAll: response.data.data.total,
               loadingFullpage: false,
               loading: false,
               formValue: values,
               pagination: {
                  total: response.data.data.total,
                },
            })
         }).catch(
            error => console.error(`Error: ${error}`)
         )
      })
   };

   fetchListLearningESS = async () => {
      const { token } = getToken()
      const { client, location, match } = this.props;
      const { offset, limit, employeeCodes, pageData } = this.state;

      await this.setState({
         loading: true,
      });

      const API_DEVICE_KEY = atob(apiKeyNews())

      const headers = {
         'Content-Type': 'application/json',
         'Authorization': `Bearer ${token}`,
         'apiKey': API_DEVICE_KEY
       }
       console.log('pageData', pageData)

      axios.post(`${workforce()}/fetchListLearningESS/`,{
         // Authorization: token,
         // apiKey: API_DEVICE_KEY,
         args:{
            ...pageData,
            empCode: employeeCodes,
            // empCode:"415023",
            // searchKeyword: {
            //    courseName: "",
            //    categoryId:"",
            //    learningType:"",
            //    learningStatus:""
            // }
         }
      },
      {
         headers: headers
      })
      .then(async (response) => {
         await this.setState({
            dataTalbe: response.data.data.data,
            dataTalbeTotalAll: response.data.data.total,
            loadingFullpage: false,
            loading: false,
            pagination: {
               total: response.data.data.total,
            },
         })
      }).catch(
         error => console.error(`Error: ${error}`)
      )
   };

   fetchEnumByCondition = async (dropDownType) =>{
      const { token } = getToken()
      const { client, location, match } = this.props;
      const { offset, limit, employeeCodes } = this.state;

      await this.setState({
         loading: true,
      });

      const API_DEVICE_KEY = atob(apiKeyNews())

      const headers = {
         'Content-Type': 'application/json',
         'Authorization': `Bearer ${token}`,
         'apiKey': API_DEVICE_KEY
       }

      axios.post(`${workforce()}/fetchEnumByCondition/`,{
         condition : {
               where: {
                     isDeleted: 0,
                     enumType: dropDownType
               },
               order :[
                  [
                     "captionTh",
                     "ASC"
                  ]
               ]
         }
      },
      {
         headers: headers
      })
      .then(async (response) => {
         let dropDownRetrue = [];
         await response.data.data.map((values, keys) => {
            dropDownRetrue.push({
              value: values.name,
              label: values.captionTh,
            });
          });

         await this.setState({
            // dropDownlearningType: dropDownRetrue
            ["dropDownType" + dropDownType]: dropDownRetrue,
            // dataTalbe: response.data.data.data,
            // loadingFullpage: false,
            // loading: false,
         })
      }).catch(
         error => console.error(`Error: ${error}`)
      )
   };

   fetchListCategory = async () =>{
      const { token } = getToken()
      const { client, location, match } = this.props;
      const { offset, limit, employeeCodes } = this.state;

      await this.setState({
         loading: true,
      });

      const API_DEVICE_KEY = atob(apiKeyNews())

      const headers = {
         'Content-Type': 'application/json',
         'Authorization': `Bearer ${token}`,
         'apiKey': API_DEVICE_KEY
       }

      axios.post(`${workforce()}/fetchListCategory/`,{
         args:{
            offset: 0,
         }
      },
      {
         headers: headers
      })
      .then(async (response) => {
         let dropDownRetrue = [];
         await response.data.data.data.map((values, keys) => {
            dropDownRetrue.push({
              value: values.id,
              label: values.categoryName,
            });
          });

         await this.setState({
            dropDownCategory: dropDownRetrue
            // dataTalbe: response.data.data.data,
            // loadingFullpage: false,
            // loading: false,
         })
      }).catch(
         error => console.error(`Error: ${error}`)
      )
   };

   clearInput = async () =>{
      await this.setState({
         pageData: {
            offset: 0,
            limit: 10,
         },
         currentPage: 1
      })
		await this.props.form.resetFields();
     
      await this.fetchListLearningESS()
	}

   personnelHistoryReport = async () =>{
      const { token } = getToken()
      const { client, location, match } = this.props;
      const { offset, limit, employeeCodes, formValue } = this.state;

      await this.setState({
         loadingFullpage: true,
      });

      const API_DEVICE_KEY = atob(apiKeyNews())

      const headers = {
         'Content-Type': 'application/json',
         'Authorization': `Bearer ${token}`,
         'apiKey': API_DEVICE_KEY
       }

      axios.post(`${checkLinkURL()}/export/pdf/personnelHistoryReport`,{
         args:{
            offset: 0,
            limit: 10,
            empCode: employeeCodes,
            searchKeyword: {
               courseName: formValue?.courseName ? formValue?.courseName : "" ,
               learningType: formValue?.learningType ? formValue?.learningType : "" ,
               subType: formValue?.subType ? formValue?.subType : "" ,
               learningStatus: formValue?.learningStatus ? formValue?.learningStatus : "" ,
               categoryId: formValue?.categoryId ? formValue?.categoryId : "" ,
            }
         }
      },
      {
         headers: headers,
      })
      .then(async (response) => {
            const link = document.createElement('a');
            link.href = `data:application/pdf;base64,${response.data.data.base64}`
            link.setAttribute(
               'download',
               `รายงานประวัติการพัฒนาบุคลากร.pdf`,
            );
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);

            await this.setState({
               loadingFullpage: false
            })
      }).catch(
         error => console.error(`Error: ${error}`)
      )
   };


   async componentDidMount() {
      await this.fetchProfile();
      Promise.all(
         [
            this.fetchEnumByCondition("learningType"),
            this.fetchEnumByCondition("learningStatus"),
            this.fetchEnumByCondition("subTypeLearning"),
            this.fetchListCategory()
         ]
      ).then(() => {
         this.fetchListLearningESS()
      });
   }

  render() {
    const { match } = this.props;
    const {
      currentPage,
      dataTalbe,
      columns,
      loading,
      pagination,
      valuesEndDate,
      disabledDateStart,
      endStartValues,
      preLoadSubmit,
      dropdownLeaveType,
      ddStartYear,
      ddEndYear,
      loadingFullpage,
      loginPerson,
      dropDownlearningType,
      dropDownCategory,
      dataTalbeTotalAll
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    console.log('dropDownlearningType', dataTalbe)
    return (
      <Container match={match}>
         <Spin spinning={loadingFullpage} delay={0}>
            <div className="card-container" id="page-profile">
               <div className="px-5 py-5 box-color-white ">
                  {/* <Row
                     gutter={16}
                     type="flex"
                     justify="left"
                     align="top"
                     className="pt-4"
                  >
                     {
                        loginPerson &&
                        <>
                            <Col xs={24} md={18} className="">
                              <Title level={4} style={{ marginTop: 10, marginBottom: 5 }} className="mb-3">
                                 {loginPerson?.title}{loginPerson?.firstName} {loginPerson?.lastName}
                              </Title>
                              <Text>
                                 ฝ่าย : {loginPerson?.divisionName}<br></br>
                                 ตำแหน่ง : - 
                              </Text>
                           </Col>
                           <Col xs={24} md={24} className="py-2">
                              <hr></hr>
                           </Col>
                        </>
                     }
                    
                  </Row> */}

                  <Collapse >
                     <Panel header="ค้นหา" key="1">
                        <Form onSubmit={this.handleSubmitfetchListLearningESS} className="px-4">
                           <Row
                              gutter={16}
                              type="flex"
                              justify="left"
                              align="top"
                              className="pb-2"
                           >
                              <Col xs={24} md={12}>
                                 <Form.Item label={"ชื่อหลักสูตร"} className="mb-0">
                                    { getFieldDecorator("courseName", {
                                       initialValue: '',
                                       rules:  [{ 
                                          required:false, 
                                       }],
                                    })(
                                       <Input 
                                          className='block-news' 
                                       />
                                    )}
                                 </Form.Item>
                              </Col>

                              <Col xs={24} md={6}>
                                 <Form.Item label={"ประเภทการพัฒนา"} className="mb-0">
                                    { getFieldDecorator("learningType", {
                                       initialValue: '',
                                       rules:  [{ 
                                          required:false, 
                                       }],
                                    })(
                                       <Select style={{ width: "100%" }} >
                                          <Option value={''}>ทั้งหมด</Option>
                                          {
                                             this.state.dropDownTypelearningType &&
                                             this.state.dropDownTypelearningType.map((values, keys) => (
                                                <Option value={values.value}>{values.label}</Option>

                                             ))
                                          }
                                       </Select>
                                    )}
                                 </Form.Item>
                              </Col>

                              <Col xs={24} md={6}>
                                 <Form.Item label={"รูปแบบ"} className="mb-0">
                                    { getFieldDecorator("subType", {
                                       initialValue: "",
                                       rules:  [{ 
                                          message: 'กรุณากรอกหรือเลือก รูปแบบ',
                                       }],
                                    })(
                                       <Select style={{ width: "100%" }} >
                                          <Option value={''}>ทั้งหมด</Option>
                                          {
                                             this.state.dropDownTypesubTypeLearning &&
                                             this.state.dropDownTypesubTypeLearning.map((values, keys) => (
                                                <Option value={values.value}>{values.label}</Option>
                                             ))
                                          }
                                       </Select>
                                    )}
                                 </Form.Item>
                              </Col>

                              <Col xs={24} md={12}>
                                 <Form.Item label={"หมวดหมู่หลักสูตร"} className="mb-0">
                                    { getFieldDecorator("categoryId", {
                                       initialValue: '',
                                       rules:  [{ 
                                          // type: 'array',
                                          required:false, 
                                       }],
                                    })(
                                       <Select style={{ width: "100%" }} >
                                          <Option value={''}>ทั้งหมด</Option>
                                          {
                                             dropDownCategory.map((values, keys) => (
                                                <Option value={values.value}>{values.label}</Option>

                                             ))
                                          }
                                       </Select>
                                    )}
                                 </Form.Item>
                              </Col>

                              

                              <Col xs={24} md={6}>
                                 <Form.Item label={"สถานะฝึกอบรม"} className="mb-0">
                                    { getFieldDecorator("learningStatus", {
                                       initialValue: "",
                                       rules:  [{ 
                                          message: 'กรุณากรอกหรือเลือก สถานะฝึกอบรม',
                                       }],
                                    })(
                                       <Select style={{ width: "100%" }} >
                                          <Option value={''}>ทั้งหมด</Option>
                                          {
                                             this.state.dropDownTypelearningStatus &&
                                             this.state.dropDownTypelearningStatus.map((values, keys) => (
                                                <Option value={values.value}>{values.label}</Option>
                                             ))
                                          }
                                       </Select>
                                    )}
                                 </Form.Item>
                              </Col>
                           </Row>
                           <Row
                              gutter={16}
                              type="flex"
                              justify="left"
                              align="top"
                              className=" mt-3"
                           >
                              
                              {/* <Col xs={24} md={24} align={"right"} style={{ paddingTop:"44px" }}> */}
                              <Col xs={24} md={24} align={"right"}>
                                 <Button 
                                    type="primary" 
                                    className="mx-2 btn-white-red" 
                                    onClick={this.clearInput}
                                 >
                                    ล้างค่า
                                 </Button>
                                 <Button
                                    type="primary"
                                    id="btn-onsearch"
                                    className="color-white"
                                    htmlType="submit"
                                    disabled={preLoadSubmit}
                                 >
                                    ค้นหา
                                 </Button>
                                 {preLoadSubmit && <Spin size="small" />}
                              </Col>
                           </Row>
                        </Form>
                     </Panel>
                  </Collapse>
                 

                  <Row
                        gutter={16}
                        type="flex"
                        justify="left"
                        align="top"
                        className="mt-4"
                     >
                     <Col xs={24} md={12} className="mb-3">
                        <strong className="color-red">รายการประวัติการพัฒนาบุคลากร</strong>
                     </Col>
                     <Col xs={24} md={12} align="right">
                        <Text>จำนวน : { dataTalbeTotalAll } รายการ </Text>
                        <Button
                           className="btn-color-default color-white ml-3"
                           type="primary "
                           htmlType="submit"
                           onClick={this.personnelHistoryReport}
                        >
                           รายงานประวัติการพัฒนาบุคลากร
                        </Button>
                     </Col>
                     <Col xs={24} md={24} align={"center"}>
                        {
                           <Table
                           locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
                           dataSource={dataTalbe}
                           columns={columns}
                           loading={loading}
                           scroll={{ x: 1300}}
                             pagination={{
                               total: pagination.total,
                               current: currentPage,
                               showSizeChanger: false,
                             }}
                           //   onChange={this.paginationChange}
                           onChange={this.paginationChange}
                           // rowCount={dataTalbe.length}
                           />
                        }
                     </Col>
                  </Row>
               </div>
            </div>
         </Spin>
      </Container>
    );
  }
}

Dashboard.defaultProps = {
  autoFocus: false,
};

Dashboard.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedDashboard = Form.create()(Dashboard);

export default withApollo(WrappedDashboard);